import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { feedService } from '@/api';

// Number of visible cards for anonymous users
const VISIBLE_CARDS = 2;

export function usePublicFeed() {
  const feedQuery = useQuery({
    queryKey: ['publicFeed'],
    queryFn: () => feedService.getPublicFeed(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Add visibility state to items (first 2 visible, rest blurred)
  const items = useMemo(() => {
    const feedItems = feedQuery.data ?? [];
    return feedItems.map((item, index) => ({
      ...item,
      isBlurred: index >= VISIBLE_CARDS,
    }));
  }, [feedQuery.data]);

  return {
    items,
    isLoading: feedQuery.isLoading,
    isError: feedQuery.isError,
    error: feedQuery.error,
  };
}
